import {
  Box,
  Card,
  CardHeader,
  Divider,
  Grid,
  Typography,
} from '@material-ui/core'
import PropTypes from 'prop-types'

import { Label, ChipPreRegistration, PhoneDisplay } from 'components'

import helpers from 'helpers'
import constants from 'constants/index'
import useStyles from '../../styles'

const BasicInfoCard = ({ preRegistration }) => {
  const classes = useStyles()

  return (
    <Card>
      <CardHeader title="Dados básicos" />
      <Divider />
      <Box className={classes.root}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <Label title="Token">
              <Typography>{preRegistration?.token}</Typography>
            </Label>
          </Grid>
          <Grid item xs={12} md={4}>
            <Label title="Tipo de contratante">
              <Typography>
                {helpers.preRegistrations.typeCompany(preRegistration)}
              </Typography>
            </Label>
          </Grid>
          <Grid item xs={12} md={4}>
            <Label title="Categoria do contratante">
              <Typography>
                {
                  constants.preRegistration.TYPE_CLIENT_LABEL[
                    preRegistration?.typeClient
                  ]
                }
              </Typography>
            </Label>
          </Grid>

          <Grid item xs={12} md={4}>
            <Label title="Documento">
              <Typography>
                {helpers.formatters.document.identify(
                  preRegistration?.document,
                )}
              </Typography>
            </Label>
          </Grid>
          <Grid item xs={12} md={4}>
            <Label title="Razão Social">
              <Typography>{preRegistration?.name}</Typography>
            </Label>
          </Grid>
          <Grid item xs={12} md={4}>
            <Label title="Nome Fantasia">
              <Typography>{preRegistration?.fantasyName || '-'}</Typography>
            </Label>
          </Grid>

          <Grid item xs={12} md={4}>
            <Label title="Telefone financeiro">
              <PhoneDisplay value={preRegistration?.phone} />
            </Label>
          </Grid>
          <Grid item xs={12} md={4}>
            <Label title="E-mail financeiro">
              <Typography>{preRegistration?.email}</Typography>
            </Label>
          </Grid>
          <Grid item xs={12} md={4}>
            <Label title="Nome do responsável financeiro">
              <Typography>{preRegistration?.contactName || '-'}</Typography>
            </Label>
          </Grid>
          <Grid item xs={12} md={4}>
            <Label title="Status">
              <ChipPreRegistration status={preRegistration?.status} />
            </Label>
          </Grid>
          <Grid item xs={12} md={4}>
            <Label title="Empresa modelo">
              <Typography>{preRegistration?.companyTemplate?.name}</Typography>
            </Label>
          </Grid>
          <Grid item xs={12} md={4}>
            <Label title="Vendedor">
              <Typography>{preRegistration?.seller?.name}</Typography>
            </Label>
          </Grid>
          <Grid item xs={12} md={4}>
            <Label title="Tipo de Serviço">
              <Typography>{preRegistration?.typeService}</Typography>
            </Label>
          </Grid>
          <Grid item xs={12} md={4}>
            <Label title="Vertical">
              <Typography>{preRegistration?.vertical}</Typography>
            </Label>
          </Grid>
        </Grid>
      </Box>
    </Card>
  )
}

BasicInfoCard.propTypes = {
  preRegistration: PropTypes.object,
}

export default BasicInfoCard
